<template>
<div>
	<quote-box>
		<ul class="quote-tab">
			<li v-for="item in tabList" :key="item.key" :class="[item.key == currentTab? 'active-tab' : '']" @click="changeTab(item.key)">{{ item.text }}</li>
			<a v-if="!isChangeParams" @click="reset" class="btn-reset pcb-reset">
				{{LANG.reset}}
			</a>
			<a v-if="isChangeParams" @click="cancelChange" class="btn-reset pcb-reset">
					{{LANG.change_cancel}}
				</a>
		</ul>
		<quote-smd></quote-smd>
		<p v-show="currentTab == 2" class="separator-box"></p>
		<h2 v-show="currentTab == 2" style="background: #FFF; padding: 10px 40px; font-size: 16px; font-weight: 700;">PCB Parameters</h2>
		<quote-pcb v-show="currentTab == 2"></quote-pcb>	
	</quote-box>
</div>
</template>

<script>
import quoteBox from '@/views/quote/quote_box.vue'
import quoteSmd from '@/components/quote/smd.vue'
import quotePcb from '@/components/quote/pcb.vue'
export default {
	components: {
		'quote-box': quoteBox,
		'quote-pcb': quotePcb,
		'quote-smd': quoteSmd
	},
	data() {
		return {
			currentTab: 1,
			tabList: [{
				key: 1,
				text: 'Stencil'
			},{
				key: 2,
				text: 'Stencil+PCB'
			}]
		}
	},
	computed: {
		isInDFM(){
			if(window.isInDFM){
				return JSON.parse(window.isInDFM)
			}
			else{
				return false
			}
		},
		isChangeParams() {
			return this.$store.state.isChangeParams
		},
		changeParams() {
			return this.$store.state.changeParams
		}
	},
	mounted() {
		this.initChangeParams()
	},
	methods: {
		changeTab(key) {
			this.currentTab = key
			if(this.currentTab == 2){
				// Stencil+PCB
				this.$store.commit("setQuoteRelation", 'pcb');
			}else{
				// Stencil
				this.$store.commit("setQuoteRelation", false);
			}		
		},
		reset(){
			this.$store.dispatch("resetQuoteParams")
			window.location.href = window.location.pathname
		},
		cancelChange() {
			this.$http.get(this.$api.cancelOrderChange + '?order_id=' + this.$route.query.order_id).then(res=>{
				if(res.code == 200) {
					window.location.href = '/order/cart/type/1'
				} else {
					this.$alert.msg(res.msg)
				}
			})
		},
		initChangeParams() {
			const query = this.$route.query
			if(query?.action_type == 1) {
				this.tabList = [{
					key: 1,
					text: 'Stencil'
				}]
			} else if(query?.action_type == 2) {
				this.tabList = [{
					key: 2,
					text: 'Stencil+PCB'
				}]
				this.changeTab(2)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.quote-tab {
	display: flex;
	background: #f2f2f2;
	// border-bottom: 2px solid #E6E6E6;
	// margin-bottom: 10px;
	height: 40px;
	position: relative;

	.btn-reset{
		min-width: 44px;
		height: 28px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666;
		font-size: 14px;
		cursor: pointer;
		padding: 0 10px;
	}

	.pcb-reset{
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
	}

	li + li {
		margin-left: 10px;
	}
}
.quote-tab li {
	// width: 224px;
	// height: 38px;
	// text-align: center;
	// line-height: 38px;
	// color: #333333;
	// border-bottom: 2px solid #fff;
	// font-size: 16px;
	// font-weight: 700;
	// cursor: pointer;
	height: 40px;
	line-height: 40px;
	width: 200px;
	display: inline-flex;
	align-items: center;
	padding-left: 22px;
	cursor: pointer;
	background: hsla(0,0%,90.2%,.6);
	border-radius: 16px 16px 0 0;
	font-size: 16px;
	font-weight: 700;
}
.quote-tab .active-tab {
	// color: #CC0000;
	// border-bottom: 2px solid #CC0000;
	color: #c00;
	background: #fff;
	box-shadow: 0 -3px 3px 0 rgb(0 0 0 / 16%);
}
.separator-box{
	position: relative;
}
.separator-box::after {
	position: absolute;
	left: 20px;
	content: "";	
	width: calc(100% - 40px);
	height: 1px;	
	background-color: #ececec;	
}
</style>